import React from "react";
import { columns } from "./Columns";
import { pictureCategoriesApi } from "@/apis/apis";
import MasterDataBaseTable from "@/pages/WebDataManagement/MasterData/MasterDataBaseTable";
import PictureCategoryModal from "@/Modals/ContentManagement/PictureCategories/Modal";

export default function PictureCategoriesPage() {
  return (
    <MasterDataBaseTable
      label="Picture Category"
      apiURL={pictureCategoriesApi}
      columns={columns()}
      ModalComponent={PictureCategoryModal}
      enableSortData={true}
      enableExport={false}
    />
  );
}
